import React, { Fragment, useEffect, useState } from "react"
import { graphql } from "gatsby"
import Navbar from "../../components/navbar/Navbar"
import { HomepageSlide } from "../../components/homepageSlide"
import { AppButton } from "../../components/button"
import { RichText } from "prismic-reactjs"
import { SocialMediaComponent } from "../../components/socialMedia"
import { getFooterConfigObject, getMenuConfigObject } from "../../utils/graphqlUtils"

import TemplateWrapper from "../../components/layout"

import Swiper from "swiper"
import "./index.scss"

import DesktopSliderCurve from "../../images/desktop-slider-curve.png"
import MobileSliderCurve from "../../images/curve-mobile.png"
import { AppLink } from "../../components/appLink"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import { Footer } from "../../components/footer/Footer"
import { NewsletterForm } from "../../components/newsletterForm"

const IndexPage = ({ data, ...props }) => {

  const isDesktop = useMediaQuery("(min-width:600px)")

  const [isLoaded, setLoaderHidden] = useState(false)

  const getRealData = () => {
    return (data &&
      data.prismic &&
      data.prismic.allHome_pages &&
      data.prismic.allHome_pages.edges &&
      data.prismic.allHome_pages.edges[0] &&
      data.prismic.allHome_pages.edges[0].node) || {}
  }

  const getActualSlides = () => {
    return realData && realData.body && realData.body.filter((section) => !section.primary.disabled)
  }

  const [realData, setRealData] = useState(getRealData())

  const [actualSlides, setActualSlides] = useState(getActualSlides)
  //
  // console.log("slides", actualSlides)

  useEffect(() => {
    if (isDesktop) {
      const verticalSwiper = new Swiper(".vertical-slider-home.swiper-container", {
        direction: "vertical",
        slidesPerView: 1,
        spaceBetween: -1,
        mousewheel: true,
        keyboard: true,
        pagination: {
          el: ".swiper-pagination-vertical",
          clickable: true,
          renderBullet: (index, className) => {
            let label
            if (index > actualSlides.length - 1) {
              label = realData.section_name
            } else {
              label = actualSlides[index].primary.section_name1
            }
            return `<span class="custom-desktop-category-slider-bullet ${className}"><span>${label}</span></span>`
          }
        }
      })
    }
    // if (!isLoaded) return

    const swiper = new Swiper(".swiper-container.kv-swiper", {
      autoplay: {
        delay: 2500,
        disableOnInteraction: false
      },
      hashNavigation: {
        watchState: true
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: (index, className) => {
          return "<span class=\"custom-desktop-slider-bullet " + className + "\"></span>"
        }
      }
    })

    const swiper2 = new Swiper(".swiper-container2", {
      // autoplay: {
      //   delay: 2500,
      //   disableOnInteraction: false
      // },
      hashNavigation: {
        watchState: true
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: (index, className) => {
          return "<span class=\"custom-desktop-slider-bullet " + className + "\"></span>"
        }
      }
    })

    // Promise.all([import("jquery"), import("round-slider")]).then(([$module, RoundSliderModule]) => {
    //
    //   const $ = $module.default
    //   const RoundSlider = RoundSliderModule.default
    //
    //   console.log($)
    //   console.log(RoundSlider)
    //   if (typeof window !== "undefined") {
    //     const length = getHomepageSlidesData().length || 3
    //     let lastValue = 50
    //     let activeBreakPointIndex = 1
    //     const interval = [5, 95]
    //     const intervalLength = interval[1] - interval[0]
    //     const indexes = []
    //     for (let i = 0; i < length; i++) {
    //       indexes.push(i)
    //     }
    //     const step = intervalLength / length
    //     const breakPoints = indexes.map(i => (i + 1) * step)
    //     let isDragging = false
    //     let draggingTimeout = null
    //
    //     // console.log(breakPoints)
    //     const traceEvent = (e) => {
    //       isDragging = true
    //       if (!draggingTimeout) {
    //         draggingTimeout = setTimeout(() => {
    //           isDragging = false
    //           clearTimeout(draggingTimeout)
    //           draggingTimeout = null
    //         }, 100)
    //       }
    //       if (lastValue > e.value) {
    //         // console.log("back")
    //         if (e.value <= breakPoints[activeBreakPointIndex - 1]) {
    //           swiper.slidePrev()
    //           if (activeBreakPointIndex !== 0)
    //             activeBreakPointIndex--
    //         }
    //
    //       } else {
    //         // console.log("next")
    //         // console.log(e.value)
    //         // console.log(breakPoints)
    //         // console.log(breakPoints[activeBreakPointIndex])
    //         // console.log(breakPoints[activeBreakPointIndex + 1])
    //         if (e.value >= breakPoints[activeBreakPointIndex + 1]) {
    //           swiper.slideNext()
    //           if (activeBreakPointIndex !== breakPoints.length - 1)
    //             activeBreakPointIndex++
    //         }
    //       }
    //
    //       $(e.handle.element).css("transform", `rotate(-${e.handle.angle}deg)`)
    //       lastValue = e.value
    //     }
    //     const slider = $("#slider").roundSlider({
    //       radius: 90,
    //       circleShape: "half-top",
    //       sliderType: "min-range",
    //       showTooltip: false,
    //       handleSize: "+45",
    //       value: 50,
    //       width: 3,
    //       drag: traceEvent
    //     })
    //
    //     swiper.on("slideChange", (e) => {
    //       // console.log((swiper.activeIndex + 1) * step)
    //       // console.log(isDragging)
    //
    //       if (!isDragging) {
    //         $("#slider").roundSlider("setValue", (swiper.activeIndex + 1) * step)
    //       }
    //     })
    //     swiper.init()
    //   }
    // })
  }, [isLoaded, isDesktop])

  const loadData = () => {
    setLoaderHidden(true)
  }

  const getHomepageSlidesData = () => {
    const realData = getRealData()
    return realData.body || []
  }

  // console.log(getHomepageSlidesData())

  const getSlideImage = (slide) => {
    return slide && slide.primary && slide.primary.sectionimage ? slide.primary.sectionimage.url : ""
  }

  const getSlideMobileImage = (slide) => {
    return slide && slide.primary && slide.primary.sectionimage && slide.primary.sectionimage.mobile && slide.primary.sectionimage.mobile.url ? slide.primary.sectionimage.mobile.url : ""
  }


  const getSlideVideo = (slide) => {
    return slide && slide.primary && slide.primary.section_video && slide.primary.section_video.url ? slide.primary.section_video.url : ""
  }

  const getContactImage = () => {
    const realData = getRealData()
    return (realData && realData.contact_section_background && realData.contact_section_background.url) || ""
  }

  const getContactMobileImage = () => {
    const realData = getRealData()
    return (realData && realData.contact_section_background && realData.contact_section_background.mobile.url) || ""
  }

  const getContactBackgroundVideo = () => {
    const realData = getRealData()
    return (realData && realData.contact_section_background_video && realData.contact_section_background_video.url) || ""
  }

  const getContactSocialMedia = () => {
    const realData = getRealData()
    return realData && realData.social_media
  }

  const getSlideProductImage = (slide) => {
    return slide && slide.primary.productimage && slide.primary.productimage.url
  }

  const getSlideDecorator = (slide) => {
    return slide && slide.primary.decorator_image && slide.primary.decorator_image.url
  }

  const getSlideLogoImage = (slide) => {
    return slide && slide.primary.section_logo_image && slide.primary.section_logo_image.url
  }

  const getSliderDesktopLeftImage = (field) => {
    return field && field.slide_image && field.slide_image.url
  }

  const getSliderDesktopRightImage = (field) => {
    return field && field.slide_image1 && field.slide_image1.url
  }

  const getSliderDesktopLeftVideo = (field) => {
    return field && field.slide_video && field.slide_video.url
  }

  const getSliderDesktopRightVideo = (field) => {
    return field && field.slide_video1 && field.slide_video1.url
  }

  const getSliderMobileTopImage = (field) => {
    return field && field.mobile_slide_image && field.mobile_slide_image.url
  }

  const getSliderMobileBottomImage = (field) => {
    return field && field.mobile_slide_image1 && field.mobile_slide_image1.url
  }

  const getSliderMobileTopVideo = (field) => {
    return field && field.mobile_slide_video && field.mobile_slide_video.url
  }

  const getSliderMobileBottomVideo = (field) => {
    return field && field.mobile_slide_video1 && field.mobile_slide_video1.url
  }

  const disableSectionFilter = (slide) => slide && slide.primary && !slide.primary.disabled

  const [product, setProduct] = useState("")

  return (
    // <PageLoader loaderDidHide={loadData}>
    <TemplateWrapper>
      <Navbar {...props} menuObject={getMenuConfigObject(data)} data={data}/>

      <div className="homepage-container">
        <div className={isDesktop ? "vertical-slider-home swiper-container" : ""}>
          <div className={isDesktop ? "swiper-wrapper" : ""}>
            {/*<div className="app-navbar-placeholder d-block d-sm-none"/>*/}
            {
              getHomepageSlidesData(data).filter(disableSectionFilter).map((slide, i) => (
                <div key={i.toString()} className={isDesktop ? "swiper-slide" : ""}>
                  <Fragment>
                    {slide.type === "carousel_section" && <Fragment>
                      {!isDesktop &&
                      <Fragment>
                        {(slide.fields && slide.fields.filter(f => f.lp_slide) || []).map((field, i) => (
                          <div key={i.toString()}>
                            <Fragment>
                              {field.left_side_link ?
                                <AppLink to={field.left_side_link}>
                                  {!getSliderMobileTopVideo(field) &&
                                  <div className="col p-0 text-center mobile-slider-slide"
                                       style={{
                                         height: "525px",
                                         backgroundImage: `url('${getSliderMobileTopImage(field)}')`,
                                         backgroundSize: "contain",
                                         backgroundRepeat: "no-repeat",
                                         backgroundPosition: "center"
                                       }}>
                                    {/*<img className="img-fluid mobile-slider-curve" src={MobileSliderCurve}/>*/}
                                  </div>
                                  }
                                  {getSliderMobileTopVideo(field) &&
                                  <div className="col p-0 text-center mobile-slider-slide">
                                    <video autoPlay="autoPlay" loop muted playsInline style={{ width: "100%", height: "525px", objectFit: "cover" }}
                                           src={getSliderMobileTopVideo(field)}/>
                                    {/*<img className="img-fluid mobile-slider-curve" src={MobileSliderCurve} style={{ zIndex: "1" }}/>*/}
                                  </div>
                                  }
                                </AppLink> :
                                <Fragment>
                                  {!getSliderMobileTopVideo(field) &&
                                  <div className="col p-0 text-center mobile-slider-slide"
                                       style={{
                                         height: "525px",
                                         backgroundImage: `url('${getSliderMobileTopImage(field)}')`,
                                         backgroundSize: "cover",
                                         backgroundRepeat: "no-repeat",
                                         backgroundPosition: "center"
                                       }}>
                                    {/*<img className="img-fluid mobile-slider-curve" src={MobileSliderCurve}/>*/}
                                  </div>
                                  }
                                  {getSliderMobileTopVideo(field) &&
                                  <div className="col p-0 text-center mobile-slider-slide">
                                    <video autoPlay="autoPlay" loop muted playsInline style={{ width: "100%", height: "525px", objectFit: "cover" }}
                                           src={getSliderMobileTopVideo(field)}/>
                                    {/*<img className="img-fluid mobile-slider-curve" src={MobileSliderCurve} style={{ zIndex: "1" }}/>*/}
                                  </div>
                                  }
                                </Fragment>}
                            </Fragment>
                            {field.right_side_link ?
                              <AppLink to={field.right_side_link}>
                                <div className="col-auto p-0">
                                  {!getSliderMobileBottomVideo(field) &&
                                  <img className="img-fluid" src={getSliderMobileBottomImage(field)}/>
                                    // <div className="col p-0 text-center"
                                    //      style={{
                                    //        height: "525px",
                                    //        backgroundImage: `url('${getSliderMobileBottomImage(field)}')`,
                                    //        backgroundSize: "cover",
                                    //        backgroundRepeat: "no-repeat",
                                    //        backgroundPosition: "center",
                                    //      }}/>
                                  }
                                  {getSliderMobileBottomVideo(field) &&
                                  <div className="col p-0 text-center">
                                    <video autoPlay="autoPlay" loop muted playsInline style={{ width: "100%", height: "525px", objectFit: "cover" }}
                                           src={getSliderMobileBottomVideo(field)}/>
                                  </div>}
                                </div>
                              </AppLink> :
                              <Fragment>
                                {!getSliderMobileBottomVideo(field) &&
                                <img className="img-fluid" src={getSliderMobileBottomImage(field)}/>
                                  // <div className="col p-0 text-center"
                                  //      style={{
                                  //        height: "525px",
                                  //        backgroundImage: `url('${getSliderMobileBottomImage(field)}')`,
                                  //        backgroundSize: "cover",
                                  //        backgroundRepeat: "no-repeat",
                                  //        backgroundPosition: "center"
                                  //      }}/>
                                }
                                {getSliderMobileBottomVideo(field) &&
                                <div className="col p-0 text-center">
                                  <video autoPlay="autoPlay" loop muted playsInline style={{ width: "100%", height: "525px", objectFit: "cover" }}
                                         src={getSliderMobileBottomVideo(field)}/>
                                </div>}
                              </Fragment>}
                          </div>
                        ))}
                      </Fragment>
                      }
                      <div className="mobile-slider-container d-sm-none">
                        <div className="swiper-container kv-swiper overflow-hidden mobile-slider">
                          <div className="swiper-wrapper">
                            {(slide.fields && slide.fields.filter(f => !f.lp_slide) || []).map((field, i) => (
                              <div key={i.toString()} className="swiper-slide d-flex flex-column">
                                {/*{!field.lp_slide ?*/}
                                <AppLink
                                  to={field.link_to_category ? "/our-chocolate/#_" + field.link_to_category._meta.uid + "#" : field.link_to_page ? field.link_to_page : "/our-chocolate"}
                                  pageContext={props.pageContext}>
                                  {!getSliderMobileTopVideo(field) &&
                                  <div className="col p-0 text-center mobile-slider-slide" style={{ backgroundImage: `url('${getSliderMobileTopImage(field)}')` }}>
                                    <img className="img-fluid mobile-slider-curve" src={MobileSliderCurve}/>
                                  </div>
                                  }
                                  {getSliderMobileTopVideo(field) &&
                                  <div className="col p-0 text-center mobile-slider-slide">
                                    <video autoPlay="autoPlay" loop muted playsInline style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                           src={getSliderMobileTopVideo(field)}/>
                                    <img className="img-fluid mobile-slider-curve" src={MobileSliderCurve} style={{ zIndex: "1" }}/>
                                  </div>
                                  }
                                  <div className="col-auto p-0 text-center kv-slider-text">
                                    {field.mobile_slide_title && RichText.render(field.mobile_slide_title)}
                                  </div>
                                </AppLink>
                                {/*  :*/}
                                {/*  <Fragment>*/}
                                {/*    {field.left_side_link ?*/}
                                {/*      <AppLink to={field.left_side_link}>*/}
                                {/*        {!getSliderMobileTopVideo(field) &&*/}
                                {/*        <div className="col p-0 text-center mobile-slider-slide" style={{ height: "500px", marginTop: '80px', backgroundImage: `url('${getSliderMobileTopImage(field)}')` }}>*/}
                                {/*          /!*<img className="img-fluid mobile-slider-curve" src={MobileSliderCurve}/>*!/*/}
                                {/*        </div>*/}
                                {/*        }*/}
                                {/*        {getSliderMobileTopVideo(field) &&*/}
                                {/*        <div className="col p-0 text-center mobile-slider-slide">*/}
                                {/*          <video autoPlay="autoPlay" loop muted playsInline style={{  marginTop: '80px', width: "100%", height: "500px", objectFit: "contain" }}*/}
                                {/*                 src={getSliderMobileTopVideo(field)}/>*/}
                                {/*          /!*<img className="img-fluid mobile-slider-curve" src={MobileSliderCurve} style={{ zIndex: "1" }}/>*!/*/}
                                {/*        </div>*/}
                                {/*        }*/}
                                {/*      </AppLink> :*/}
                                {/*      <Fragment>*/}
                                {/*        {!getSliderMobileTopVideo(field) &&*/}
                                {/*        <div className="col p-0 text-center mobile-slider-slide" style={{ height: "500px", marginTop: '80px', backgroundImage: `url('${getSliderMobileTopImage(field)}')` }}>*/}
                                {/*          <img className="img-fluid mobile-slider-curve" src={MobileSliderCurve}/>*/}
                                {/*        </div>*/}
                                {/*        }*/}
                                {/*        {getSliderMobileTopVideo(field) &&*/}
                                {/*        <div className="col p-0 text-center mobile-slider-slide">*/}
                                {/*          <video autoPlay="autoPlay" loop muted playsInline style={{ marginTop: '80px', width: "100%", height: "500px", objectFit: "contain" }}*/}
                                {/*                 src={getSliderMobileTopVideo(field)}/>*/}
                                {/*          /!*<img className="img-fluid mobile-slider-curve" src={MobileSliderCurve} style={{ zIndex: "1" }}/>*!/*/}
                                {/*        </div>*/}
                                {/*        }*/}
                                {/*      </Fragment>}*/}
                                {/*  </Fragment>*/}
                                {/*}*/}
                                {/*{field.right_side_link ?*/}
                                {/*  <AppLink to={field.right_side_link}>*/}
                                {/*    <div className="col-auto p-0 text-center kv-slider-text">*/}
                                {/*      {!getSliderMobileBottomVideo(field) &&*/}
                                {/*      <div className="col p-0 text-center"*/}
                                {/*           style={{ backgroundImage: `url('${getSliderMobileBottomImage(field)}')` }}/>}*/}
                                {/*      {getSliderMobileBottomVideo(field) &&*/}
                                {/*      <div className="col p-0 text-center">*/}
                                {/*        <video autoPlay="autoPlay" loop muted playsInline style={{ width: "100%", height: "500px", objectFit: "contain" }}*/}
                                {/*               src={getSliderMobileBottomVideo(field)}/>*/}
                                {/*      </div>}*/}
                                {/*    </div>*/}
                                {/*  </AppLink> :*/}
                                {/*  <Fragment>*/}
                                {/*    {!getSliderMobileBottomVideo(field) &&*/}
                                {/*    <div className="col p-0 text-center"*/}
                                {/*         style={{ backgroundImage: `url('${getSliderMobileBottomImage(field)}')` }}/>}*/}
                                {/*    {getSliderMobileBottomVideo(field) &&*/}
                                {/*    <div className="col p-0 text-center">*/}
                                {/*      <video autoPlay="autoPlay" loop muted playsInline style={{ width: "100%", height: "500px", objectFit: "contain" }}*/}
                                {/*             src={getSliderMobileBottomVideo(field)}/>*/}
                                {/*    </div>}*/}
                                {/*  </Fragment>*/}
                              </div>
                            ))}
                          </div>
                          <div className="swiper-pagination"/>
                        </div>
                        {/*<div style={{ position: "absolute", bottom: 0, left: "50%", transform: "translate(-50%)", zIndex: "9" }}>*/}
                        {/*  <div id="slider"/>*/}
                        {/*</div>*/}
                      </div>
                      <div className="desktop-slider-container d-none d-sm-block">
                        <div className="swiper-container2 overflow-hidden desktop-slider">
                          <div className="swiper-wrapper">
                            {(slide.fields || []).map((field, i) => (
                              <div key={i.toString()} className="swiper-slide" data-hash={`slide` + i}>
                                {!field.lp_slide ?
                                  <AppLink
                                    to={field.link_to_category ? "/our-chocolate/#" + field.link_to_category._meta.uid : field.link_to_page ? field.link_to_page : "/our-chocolate"}
                                    pageContext={props.pageContext}>
                                    <div className="h-100 w-100 d-flex">
                                      {!getSliderDesktopLeftVideo(field) &&
                                      <div className="col-6 p-0 text-center desktop-slider-slide"
                                           style={{
                                             backgroundImage: `url('${getSliderDesktopLeftImage(field)}')`
                                           }}/>
                                      }
                                      {getSliderDesktopLeftVideo(field) &&
                                      <div className="col-6 p-0 text-center desktop-slider-slide">
                                        <video loop muted playsInline autoPlay="true" style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                               src={getSliderDesktopLeftVideo(field)}/>
                                      </div>
                                      }
                                      <div className="col-6 p-0 d-flex justify-content-center align-items-center text-center">
                                        <img className="desktop-slider-curve" src={DesktopSliderCurve} style={{ zIndex: getSliderDesktopLeftVideo(field) ? "1" : "-1" }}/>
                                        <div>
                                          {field.desktop_slide_title && RichText.render(field.desktop_slide_title)}
                                        </div>
                                      </div>
                                    </div>
                                  </AppLink> :
                                  <div className="h-100 w-100 d-flex">
                                    <Fragment>
                                      {!getSliderDesktopLeftVideo(field) &&
                                      <div className="col-6 p-0 d-flex justify-content-center align-items-center text-center desktop-slider-slide">
                                        {field.left_side_link ?
                                          <AppLink to={field.left_side_link}>
                                            <div style={{
                                              height: "80vh",
                                              width: "50vw",
                                              backgroundImage: `url('${getSliderDesktopLeftImage(field)}')`,
                                              backgroundRepeat: "no-repeat",
                                              backgroundSize: "contain",
                                              backgroundPosition: "center center",
                                              marginTop: "15px"
                                            }}/>
                                          </AppLink> : <div style={{
                                            height: "80vh",
                                            width: "50vw",
                                            backgroundImage: `url('${getSliderDesktopLeftImage(field)}')`,
                                            backgroundRepeat: "no-repeat",
                                            backgroundSize: "contain",
                                            backgroundPosition: "center center",
                                            marginTop: "15px"
                                          }}/>
                                        }
                                      </div>
                                      }
                                      {getSliderDesktopLeftVideo(field) &&
                                      <div className="col-6 p-0 d-flex justify-content-center align-items-center text-center desktop-slider-slide">
                                        {field.left_side_link ?
                                          <AppLink to={field.left_side_link}>
                                            <div style={{
                                              height: "80vh",
                                              width: "50vw",
                                              marginTop: "15px"
                                            }}>
                                              <video loop muted playsInline autoPlay="true" style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                                     src={getSliderDesktopLeftVideo(field)}/>
                                            </div>
                                          </AppLink> :
                                          <div style={{
                                            height: "80vh",
                                            width: "50vw",
                                            marginTop: "15px"
                                          }}>
                                            <video loop muted playsInline autoPlay="true" style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                                   src={getSliderDesktopLeftVideo(field)}/>
                                          </div>}
                                      </div>
                                      }
                                    </Fragment>
                                    {!getSliderDesktopRightVideo(field) ?
                                      <div className="col-6 p-0 d-flex justify-content-center align-items-center text-center">
                                        <img className="desktop-slider-curve" src={DesktopSliderCurve} style={{ zIndex: 1 }}/>
                                        {field.right_side_link ?
                                          <AppLink to={field.right_side_link}>
                                            <div style={{
                                              height: "80vh",
                                              width: "50vw",
                                              backgroundImage: `url('${getSliderDesktopRightImage(field)}')`,
                                              backgroundRepeat: "no-repeat",
                                              backgroundSize: "contain",
                                              backgroundPosition: "left center",
                                              marginTop: "15px"
                                            }}/>
                                          </AppLink> :
                                          <div style={{
                                            height: "80vh",
                                            width: "50vw",
                                            backgroundImage: `url('${getSliderDesktopRightImage(field)}')`,
                                            backgroundRepeat: "no-repeat",
                                            backgroundSize: "contain",
                                            backgroundPosition: "left center",
                                            marginTop: "15px"
                                          }}/>}
                                      </div> :
                                      <div className="col-6 p-0 d-flex justify-content-center align-items-center text-center">
                                        <img className="desktop-slider-curve" src={DesktopSliderCurve} style={{ zIndex: 1 }}/>
                                        {field.right_side_link ?
                                          <AppLink to={field.right_side_link}>
                                            <div style={{
                                              height: "80vh",
                                              width: "50vw",
                                              marginTop: "15px"
                                            }}>
                                              <video loop muted playsInline autoPlay="true"
                                                     style={{ width: "100%", height: "100%", objectFit: "contain", objectPosition: "left center" }}
                                                     src={getSliderDesktopRightVideo(field)}/>
                                            </div>
                                          </AppLink> :
                                          <div style={{
                                            height: "80vh",
                                            width: "50vw",
                                            marginTop: "15px"
                                          }}>
                                            <video loop muted playsInline autoPlay="true"
                                                   style={{ width: "100%", height: "100%", objectFit: "contain", objectPosition: "left center" }}
                                                   src={getSliderDesktopRightVideo(field)}/>
                                          </div>}
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            ))}
                            }
                          </div>
                          <div className="swiper-pagination"/>
                          ))}
                        </div>
                      </div>
                    </Fragment>}
                    {slide.type === "sections" &&
                    <HomepageSlide desktopImgSrc={getSlideImage(slide)} mobileImgSrc={getSlideMobileImage(slide)} videoSrc={getSlideVideo(slide)}>
                      <div className="home-product-section-text text-center">
                        <div className="d-block d-sm-none">
                          {!getSlideProductImage(slide) && getSlideLogoImage(slide) &&
                          <img src={getSlideLogoImage(slide)} alt="Heidi journey" style={{ width: "70px" }}/>
                          }
                        </div>
                        {getSlideLogoImage(slide) &&
                        <div className="d-none d-sm-block">
                          <img src={getSlideLogoImage(slide)} alt="Heidi journey" style={{ width: "70px" }}/>
                        </div>
                        }
                        {/*<div className="page-title text-center text-uppercase">*/}
                        <div
                          className={getSlideProductImage(slide) ? "page-title text-center text-uppercase extra-margin-top" : "page-title text-center text-uppercase"}>
                          {slide.primary && slide.primary.title && RichText.render(slide.primary.title)}
                        </div>
                        <div className="bottom-section-text text-center py-0 py-md-4">
                          {slide.primary && slide.primary.description && RichText.render(slide.primary.description)}
                        </div>
                        {slide.primary && slide.primary.buttontext &&
                        <AppButton className={getSlideProductImage(slide) ? "home-section-button my-2" : "home-section-button"}
                                   href={isDesktop && slide.primary?.include_newsletter_input ? slide.primary?.link + "#b2b" : !isDesktop && slide.primary?.include_newsletter_input ? slide.primary?.link + "#b-2-b" : slide.primary?.link}
                                   target={slide.primary.open_link_in_new_page ? "_blank" : "_self"}
                                   pageContext={props.pageContext}>{slide.primary.buttontext}</AppButton>}
                        {slide.primary?.include_newsletter_input &&
                        <div className="py-md-4">
                          <NewsletterForm
                            placeholder={data.prismic.allHome_pages.edges[0].node.subscribe_to_newsletter_placeholder ? data.prismic.allHome_pages.edges[0].node.subscribe_to_newsletter_placeholder : "Subscribe to our newsletter"}/>
                        </div>
                        }
                      </div>
                      {/*{slide.primary  && slide.primary.social_media_links && <SocialMediaComponent socialMediaObj={slide.primary.social_media_links}/>}*/}
                      {getSlideProductImage(slide) && <div className="home-product-image-container">
                        <img className="img-fluid home-product-image" alt="prod-img" src={getSlideProductImage(slide)}/>
                      </div>}
                      {getSlideDecorator(slide) &&
                      <img className="img-fluid slide-decorator-image d-none d-sm-block" alt="prod-img" src={getSlideDecorator(slide)}/>
                      }
                    </HomepageSlide>}
                  </Fragment>
                </div>
              ))
            }
            <div className="swiper-slide contact-slide">
              <HomepageSlide desktopImgSrc={getContactImage()} mobileImgSrc={getContactMobileImage()} videoSrc={getContactBackgroundVideo()}>
                <div className="text-center mt-md-5">
                  {data.prismic.allHome_pages.edges[0].node.section_logo_image && data.prismic.allHome_pages.edges[0].node.section_logo_image.url &&
                  <img src={data.prismic.allHome_pages.edges[0].node.section_logo_image.url} alt="Heidi journey" style={{ width: "70px" }} className="mt-md-3"/>
                  }
                  <h1 className="page-title text-center text-uppercase">
                    {data.prismic.allHome_pages.edges[0].node.section_name ? data.prismic.allHome_pages.edges[0].node.section_name : "Contact"}
                  </h1>
                  <div className="bottom-section-text text-center py-0 pt-md-4">
                    {RichText.render(data.prismic.allHome_pages.edges[0].node.contact_details)}
                    <a className="email-link" href={`mailto:${data.prismic.allHome_pages.edges[0].node.email}`}>{data.prismic.allHome_pages.edges[0].node.email}</a>
                  </div>
                  {data.prismic.allHome_pages.edges[0].node.button_text &&
                  <AppButton className="home-section-button home-contact-button" href="/contact" pageContext={props.pageContext}>
                    {data.prismic.allHome_pages.edges[0].node.button_text}
                  </AppButton>}
                  {props.pageContext.lang !== "ro" && !data.prismic.allHome_pages.edges[0].node.subscribe_input_disabled &&
                  <NewsletterForm language={props.pageContext.lang}
                                  placeholder={data.prismic.allHome_pages.edges[0].node.subscribe_to_newsletter_placeholder ? data.prismic.allHome_pages.edges[0].node.subscribe_to_newsletter_placeholder : "Subscribe to our newsletter"}/>
                  }
                </div>
                {getContactSocialMedia() && <SocialMediaComponent socialMediaObj={getContactSocialMedia()}/>}
                <Footer data={getFooterConfigObject(data)}/>
              </HomepageSlide>
            </div>
          </div>
        </div>
        <div className="pagination-wrapper vw-100">
          <div className="container p-0 d-none d-sm-block position-relative">
            <div className="swiper-pagination-vertical"/>
          </div>
        </div>
      </div>
    </TemplateWrapper>
    // </PageLoader>
  )
}

export default IndexPage

export const pageQuery = graphql`
    query HomePageTemplateQuery($lang: String) {
        prismic {
            allHome_pages(lang: $lang)  {
                edges {
                    node {
                        contact_section_background_video {
                            ... on PRISMIC__FileLink {
                                url
                            }
                        }
                        section_name
                        button_text
                        contact_details
                        contact_section_background
                        email
                        phone_number
                        subscribe_input_disabled
                        subscribe_to_newsletter_placeholder
                        section_logo_image
                        social_media {
                            ... on PRISMIC_Social_media_section {
                                _linkType
                                youtube {
                                    disabled
                                    icon
                                    link {
                                        ... on PRISMIC__ExternalLink {
                                            _linkType
                                            url
                                        }
                                    }
                                }
                                facebook {
                                    disabled
                                    icon
                                    link {
                                        ... on PRISMIC__ExternalLink {
                                            _linkType
                                            url
                                        }
                                    }
                                }
                                instagram {
                                    disabled
                                    icon
                                    link {
                                        ... on PRISMIC__ExternalLink {
                                            _linkType
                                            url
                                        }
                                    }
                                }
                                linkedin {
                                    disabled
                                    icon
                                    link {
                                        ... on PRISMIC__ExternalLink {
                                            _linkType
                                            url
                                        }
                                    }
                                }
                                twitter {
                                    disabled
                                    icon
                                    link {
                                        ... on PRISMIC__ExternalLink {
                                            _linkType
                                            url
                                        }
                                    }
                                }
                            }
                        }
                        body {
                            ... on PRISMIC_Home_pageBodyCarousel_section {
                                type
                                label
                                primary {
                                    disabled
                                    section_name1
                                }
                                fields {
                                    lp_slide
                                    slide_video {
                                        ... on PRISMIC__FileLink {
                                            url
                                        }
                                    }
                                    mobile_slide_video {
                                        ... on PRISMIC__FileLink {
                                            url
                                        }
                                    }
                                    slide_video1 {
                                        ... on PRISMIC__FileLink {
                                            url
                                        }
                                    }
                                    mobile_slide_video1 {
                                        ... on PRISMIC__FileLink {
                                            url
                                        }
                                    }
                                    left_side_link
                                    right_side_link
                                    slide_image
                                    slide_image1
                                    mobile_slide_title
                                    desktop_slide_title
                                    mobile_slide_image
                                    mobile_slide_image1
                                    link_to_page
                                    link_to_category {
                                        _linkType
                                        ... on PRISMIC_Product_category {
                                            name
                                            _meta {
                                                uid
                                            }
                                        }
                                    }
                                }
                            }
                            ... on PRISMIC_Home_pageBodySections {
                                type
                                label
                                primary {
                                    title
                                    description
                                    disabled
                                    link
                                    open_link_in_new_page
                                    buttontext
                                    sectionimage
                                    productimage
                                    section_name1
                                    decorator_image
                                    section_logo_image
                                    include_newsletter_input
                                    section_video {
                                        ... on PRISMIC__FileLink {
                                            url
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            allMenus(lang: $lang) {
                edges {
                    node {
                        what_makes_heidi_unique_label
                        what_makes_heidi_unique_disabled
                        promo_campaign_label
                        promo_campaign_disabled
                        products_label
                        products_disabled
                        online_shop_label
                        online_shop_disabled
                        contact_disabled
                        chocolate_lover_disabled
                        contact_label
                        chocolate_lover_label
                        chocolate_label
                        chocolate_disabled
                        careers_label
                        careers_disabled
                        shops_page_label
                        shops_page_disabled
                    }
                }
            }
            allFooter_privacy_policy_linkss(lang: $lang) {
                edges {
                    node {
                        footer_privacy_policy_links {
                            link_title
                            link_resource {
                                ... on PRISMIC__FileLink {
                                    _linkType
                                    url
                                }
                            }
                        }
                    }
                }
            }
            allCookie_consents(lang: $lang) {
                edges {
                    node {
                        cookie_consent_text
                        cookie_consent_link {
                            ... on PRISMIC__ExternalLink {
                                url
                            }
                        }
                        cookie_consent_link_text
                        cookie_consent_button_text
                    }
                }
            }
        }
    }
`
